import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const ForstaGangen = lazy(() => import("@/pages/elavtal/ForstaGangen"));

export const Route = createFileRoute("/elavtal/forsta-gangen")({
  head: () => seoHead("/elavtal/forsta-gangen", { description: "Är det första gången du tecknar elavtal? Här får du en enkel steg-för-steg-guide som hjälper dig välja rätt från start." }),
  component: () => <ForstaGangen />,
});
